'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPaperclip = function IoPaperclip(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.1 12.1c0.5 0 0.9 0.4 0.9 0.9v15.3c0 2.2-0.8 3.8-1.9 4.9-1.1 1.2-2.8 1.8-4.3 1.8-3.2 0-6.3-2.4-6.3-6.9v-18.3c0-1.8 0.9-3.4 2.3-4.2s3-0.8 4.4 0 2.3 2.4 2.3 4.2l-0.1 17.6c0 1-0.2 1.9-0.7 2.5s-1.2 1-1.9 1c-1.4 0-2.7-1.2-2.7-3.5v-13.5c0-0.5 0.5-0.9 0.9-0.9s0.9 0.4 0.9 0.9v13.5c0 1.1 0.4 1.7 0.9 1.7 0.1 0 0.3-0.2 0.5-0.3 0.2-0.4 0.4-0.8 0.4-1.4v-17.6c0-1.1-0.5-2.1-1.3-2.6s-1.9-0.5-2.8 0-1.3 1.5-1.3 2.6v18.3c0 3.5 2.3 5 4.5 5s4.4-1.5 4.4-4.9v-15.2c0-0.5 0.5-0.9 0.9-0.9z' })
        )
    );
};

exports.default = IoPaperclip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/paperclip.js
// module id = 2854
// module chunks = 168707334958949